import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const nodes = [{
    label: 'Days 1–3',
    title: 'The Accumulation Phase',
    body: "The active ingredients begin to build up in your system via the transdermal patch. You likely won't notice any changes yet. Continue with your normal routine and any pads you currently use."
  }, {
    label: 'Day 4–5',
    title: 'The First Signs',
    body: "Many women report their first 'non-event' around this time. A sneeze or a cough that doesn't result in a leak. You may notice you are waking up less frequently during the night."
  }, {
    label: 'Day 6–7',
    title: 'Noticeable Difference',
    body: 'The nerve-muscle communication pathway is now receiving consistent support. The urgency to find a toilet immediately begins to subside. You may find you are using fewer pads.'
  }, {
    label: 'Week 2',
    title: 'Building Confidence',
    body: "The physical changes start to become psychological changes. The constant background anxiety of 'where is the nearest toilet' starts to fade. You begin to trust your body again."
  }, {
    label: 'Week 3–4',
    title: 'The New Normal',
    body: 'For most women, this is when they stop buying pads entirely. The occasional leak may still happen under extreme stress (like a heavy coughing fit), but daily life is vastly improved.'
  }, {
    label: 'Month 2–3',
    title: 'Full Restoration',
    body: 'The nerve pathways are fully supported. You are no longer planning your life around your bladder. You can laugh freely, exercise, and travel without the mental burden of incontinence.',
    isFinal: true
  }];
  return <section className="bg-cream py-12 md:py-20 px-5" data-id="element-584">
      <div className="max-w-[780px] mx-auto" data-id="element-585">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-586">
          <div className="font-inter text-[12px] uppercase tracking-[0.1em] text-secondary mb-3" data-id="element-587">
            What to Expect
          </div>
          <h2 className="font-playfair text-[28px] md:text-[32px] text-ink font-semibold" data-id="element-588">
            The First Two Weeks — Day by Day
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative" data-id="element-589">
          <div className="absolute left-[20px] md:left-1/2 top-0 bottom-0 w-[1px] border-l border-dashed border-gold md:-translate-x-1/2 z-0" data-id="element-590"></div>

          <div className="space-y-8 md:space-y-0 relative z-10" data-id="element-591">
            {nodes.map((node, index) => {
            const isEven = index % 2 === 0;
            const num = String(index + 1).padStart(2, '0');
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} className={`flex flex-col md:flex-row items-start md:items-center w-full ${isEven ? 'md:justify-start' : 'md:justify-end'} relative md:-mt-8 first:mt-0`} data-id="element-592">
                  {/* Mobile Layout */}
                  <div className="md:hidden flex w-full" data-id="element-593">
                    <div className="w-[44px] shrink-0 flex justify-center relative" data-id="element-594">
                      <div className={`w-[44px] h-[44px] rounded-full border-2 ${node.isFinal ? 'border-gold bg-forest' : 'border-forest bg-white'} flex items-center justify-center font-playfair font-bold text-[15px] ${node.isFinal ? 'text-gold' : 'text-forest'} z-10 shadow-subtle`} data-id="element-595">
                        {num}
                      </div>
                    </div>
                    <div className="ml-6 w-full pb-8" data-id="element-596">
                      <div className={`rounded-xl p-5 shadow-subtle ${node.isFinal ? 'bg-forest text-white' : 'bg-white'}`} data-id="element-597">
                        <div className={`font-inter text-[11px] uppercase tracking-[0.15em] mb-1.5 ${node.isFinal ? 'text-gold' : 'text-forest'}`} data-id="element-598">
                          {node.label}
                        </div>
                        <h3 className={`font-inter font-semibold text-[15px] mb-2 ${node.isFinal ? 'text-white' : 'text-ink'}`} data-id="element-599">
                          {node.title}
                        </h3>
                        <p className={`font-inter text-[14px] leading-relaxed ${node.isFinal ? 'text-white/80' : 'text-secondary'}`} data-id="element-600">
                          {node.body}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Desktop Layout */}
                  <div className={`hidden md:flex w-[50%] ${isEven ? 'pr-12 justify-end' : 'pl-12 justify-start ml-auto'} relative`} data-id="element-601">
                    <div className={`absolute top-1/2 -translate-y-1/2 ${isEven ? 'right-[-22px]' : 'left-[-22px]'} w-[44px] h-[44px] rounded-full border-2 ${node.isFinal ? 'border-gold bg-forest' : 'border-forest bg-white'} flex items-center justify-center font-playfair font-bold text-[15px] ${node.isFinal ? 'text-gold' : 'text-forest'} z-10 shadow-subtle`} data-id="element-602">
                      {num}
                    </div>
                    <div className={`w-full max-w-[320px] rounded-xl p-5 shadow-subtle ${node.isFinal ? 'bg-forest text-white' : 'bg-white'}`} data-id="element-603">
                      <div className={`font-inter text-[11px] uppercase tracking-[0.15em] mb-1.5 ${node.isFinal ? 'text-gold' : 'text-forest'}`} data-id="element-604">
                        {node.label}
                      </div>
                      <h3 className={`font-inter font-semibold text-[15px] mb-2 ${node.isFinal ? 'text-white' : 'text-ink'}`} data-id="element-605">
                        {node.title}
                      </h3>
                      <p className={`font-inter text-[14px] leading-relaxed ${node.isFinal ? 'text-white/80' : 'text-secondary'}`} data-id="element-606">
                        {node.body}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}